import { render, staticRenderFns } from "./GatewaysView.vue?vue&type=template&id=1ad2ab27&lang=pug&"
import script from "./GatewaysView.vue?vue&type=script&lang=ts&"
export * from "./GatewaysView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports